import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'ui/styled';
import { UploadOutlined, InboxOutlined } from '@ant-design/icons';
import { Upload, Alert, message } from 'antd';
import { FILE_ADDED_TEXT, cautionTextItems, getPapaparseConfig } from './helper';
import { StyledDiv, StyledLink } from './styled';
var Dragger = Upload.Dragger;
export var SUBMIT_ERRORS = {
    NO_IDS: 'Make sure you uploaded file that fit the rules'
};
var beforeUpload = function (file) {
    var isCsv = file.type === 'text/csv';
    if (!isCsv) {
        message.error("".concat(file.name, " is not a CSV file!"));
    }
    return isCsv || Upload.LIST_IGNORE;
};
var BulkCsvUpload = function (_a) {
    var disabled = _a.disabled, submitBulkCreate = _a.submitBulkCreate, type = _a.type, tpaId = _a.tpaId;
    var _b = useState(false), isVisible = _b[0], setIsVisible = _b[1];
    var _c = useState(null), uid = _c[0], setUid = _c[1];
    var _d = useState([]), attributes = _d[0], setAttributes = _d[1];
    var generateAddedText = FILE_ADDED_TEXT === null || FILE_ADDED_TEXT === void 0 ? void 0 : FILE_ADDED_TEXT[type];
    var addedText = generateAddedText(attributes === null || attributes === void 0 ? void 0 : attributes.length);
    var cautionText = cautionTextItems === null || cautionTextItems === void 0 ? void 0 : cautionTextItems[type];
    var isOrganizations = type === 'benefit_organizations';
    var onRemove = function () {
        setUid(null);
        setAttributes([]);
        submitBulkCreate([]);
    };
    var onChange = function (_a) {
        var file = _a.file;
        getPapaparseConfig(file === null || file === void 0 ? void 0 : file.originFileObj, uid, type, function (attributes, fuid) {
            setAttributes(attributes);
            setUid(fuid);
        });
    };
    var onComplete = function () {
        if (!attributes.length) {
            return message.error(SUBMIT_ERRORS.NO_IDS);
        }
        submitBulkCreate(attributes);
        setIsVisible(false);
    };
    useEffect(function () { return onRemove(); }, [tpaId]);
    return (_jsxs(_Fragment, { children: [_jsx(StyledDiv, { children: !!attributes.length && !isOrganizations ? (_jsxs("p", { children: [_jsx("span", { children: addedText }), _jsx(StyledLink, { btntype: "link", onClick: onRemove, "data-test": "bulkUploadRemoveBtn", children: "remove" }), _jsx("span", { children: "and reupload attachment." })] })) : (_jsx(Button, { icon: _jsx(UploadOutlined, {}), disabled: disabled, onClick: function () { return setIsVisible(true); }, "data-test": "bulkUploadBtn", children: "Bulk Upload CSV" })) }), isVisible && (_jsxs(Modal, { open: isVisible, onOk: onComplete, onCancel: function () { return setIsVisible(false); }, title: "Bulk Organization Upload", "data-test": "bulkUploadModal", children: [_jsx(Alert, { title: "Proceed with caution", type: "error", showIcon: true, style: { marginBottom: 10 } }), _jsx("ul", { children: cautionText.map(function (item) { return (_jsx("li", { children: item })); }) }), !!(attributes === null || attributes === void 0 ? void 0 : attributes.length) ? (_jsxs("p", { children: [_jsx("span", { children: addedText }), _jsx(StyledLink, { btntype: "link", onClick: onRemove, "data-test": "bulkUploadModalRemoveBtn", children: "remove" }), _jsx("span", { children: "and reupload attachment." })] })) : (_jsxs(Dragger, { multiple: false, onChange: onChange, style: { margin: '10px 0' }, beforeUpload: beforeUpload, accept: ".csv", showUploadList: false, "data-test": "bulkUploadModalDragger", children: [_jsx("p", { className: "ant-upload-drag-icon", children: _jsx(InboxOutlined, {}) }), _jsx("p", { className: "ant-upload-text", children: "Click or drag file to this area to upload" })] }))] }))] }));
};
export default BulkCsvUpload;
